'use client';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';
import { Section } from '~/components';
import { HomeRankedKeywordItem } from '~/app/(home)/_components';
import { IcChevronDown, Typography, theme } from '@bgzt/ui';
import { KeywordsRanking } from '~/apis/mercari/get-keywords-rankings';

import styles from './RollingDisplay.module.css';

type Props = {
  keywords?: KeywordsRanking[];
  onKeywordClick?: (value: KeywordsRanking, index?: number) => void;
  onArrowClick?: () => void;
};

export const RollingDisplay = ({ keywords, onKeywordClick, onArrowClick }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const item = keywords?.[currentIndex];

  useEffect(() => {
    if (!keywords) return;
    const animationDuration = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % (keywords?.length ?? 0));
    }, 2000);
    return () => {
      clearInterval(animationDuration);
    };
  }, [keywords]);

  if (!keywords || keywords?.length < 1) return null;

  return (
    <Section>
      <div className={styles.container}>
        <div className={styles.label}>
          <Typography variant="L14" color={'red-500'}>
            인기
          </Typography>
        </div>
        <div className={styles.animateWrapper}>
          <AnimatePresence>
            {item && (
              <motion.div
                key={+new Date()}
                initial={{
                  y: 50,
                  opacity: 0,
                }}
                animate={{
                  y: 0,
                  opacity: 1,
                }}
                exit={{
                  y: -50,
                  opacity: 0,
                }}
                transition={{
                  duration: 0.45,
                  ease: [0.41, 0.01, 0.56, 1],
                }}
                style={{ position: 'absolute', width: '100%' }}
              >
                <HomeRankedKeywordItem rankedKeyword={item} onClick={() => onKeywordClick?.(item, currentIndex)} />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        <div className={styles.arrow} onClick={onArrowClick}>
          <IcChevronDown size={14} fill={theme.colors['gray-300']} />
        </div>
      </div>
    </Section>
  );
};
